import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PageMetaWithTotalSchema } from '../pagination';

export const UserStatusSchema = z.enum(['pending', 'active', 'disabled']);
export type UserStatus = z.infer<typeof UserStatusSchema>;

const UserRoleSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  isSystem: z.boolean(),
});

export const UserListItemSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  displayName: z.string(),
  githubUsername: z.string().nullable(),
  githubUsernameLocked: z.boolean(),
  /** coalesce(photo_url, github_avatar_url) — see user-ref.ts for precedence. */
  avatarUrl: z.string().nullable(),
  roles: z.array(UserRoleSchema).min(1),
  status: UserStatusSchema,
  createdAt: z.string(),
  lastSeenAt: z.string().nullable(),
  welcomedAt: z.string().nullable(),
});

export type UserListItem = z.infer<typeof UserListItemSchema>;

export const ListUsersQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(25),
  cursor: z.string().optional(),
  q: z.string().trim().min(1).optional(),
  status: UserStatusSchema.optional(),
});

export const ListUsersResponseSchema = z.object({
  data: z.array(UserListItemSchema),
  meta: PageMetaWithTotalSchema,
});

export const listUsers = defineEndpoint({
  method: 'GET',
  path: '/v1/users',
  params: z.object({}),
  query: ListUsersQuerySchema,
  body: z.undefined(),
  response: ListUsersResponseSchema,
});
